import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthServiceService } from './auth-service.service';
import { ReceivingOrderListingResponse } from '../models/receiving.model';

@Injectable({
    providedIn: 'root'
})
export class ReceivingAdminService {
    private _orders = new BehaviorSubject<ReceivingOrderListingResponse | null>(null);
    private loadingSubject = new BehaviorSubject<boolean>(false);

    orders$ = this._orders.asObservable();
    loading$ = this.loadingSubject.asObservable();

    get _liveApiUrl() {
        return this.authService._liveApiUrl;
    }

    constructor(
        private http: HttpClient,
        public authService: AuthServiceService
    ) { }

    /**
     * Fetch receiving orders listing
     * @param page Page number (1-indexed for the API)
     * @param searchText Search text filter
     */
    getReceivingOrders(page: number = 1, searchText?: string, status?: string, orderType?: string, orderDate?: string): Observable<ReceivingOrderListingResponse> {
        this.loadingSubject.next(true);

        let url = `${this._liveApiUrl}/company/recieving-admin-order-listing/?page=${page}`;
        if (searchText && searchText.trim()) {
            url += `&search_text=${encodeURIComponent(searchText.trim())}`;
        }
        if (status && status.trim()) {
            url += `&order_status=${encodeURIComponent(status.trim())}`;
        }
        if (orderType && orderType.trim()) {
            url += `&order_type=${encodeURIComponent(orderType.trim())}`;
        }
        if (orderDate && orderDate.trim()) {
            url += `&order_date=${encodeURIComponent(orderDate.trim())}`;
        }

        return this.http.get<ReceivingOrderListingResponse>(url).pipe(
            map((data: any) => {
                this.loadingSubject.next(false);
                this._orders.next(data);
                return data;
            }),
            catchError((error) => {
                this.loadingSubject.next(false);
                return this.authService.handleError(error);
            })
        );
    }

    /**
     * Get receiving order counts for filter chips
     */
    getReceivingOrderCounts(driver_id?: string, order_status?: string, today_date?: string, order_type?: string, order_date?: string, search_text?: string): Observable<any> {
        let params: string[] = [];
        if (driver_id) params.push(`driver_id=${encodeURIComponent(driver_id)}`);
        if (order_status) params.push(`order_status=${encodeURIComponent(order_status)}`);
        if (today_date) params.push(`today_date=${encodeURIComponent(today_date)}`);
        if (order_type) params.push(`order_type=${encodeURIComponent(order_type)}`);
        if (order_date) params.push(`order_date=${encodeURIComponent(order_date)}`);
        if (search_text) params.push(`search_text=${encodeURIComponent(search_text)}`);

        const tail = params.length > 0 ? `?${params.join('&')}` : '';
        const url = `${this._liveApiUrl}/company/receiving-admin-order-counts/${tail}`;

        return this.http.get<any>(url).pipe(
            catchError((error) => this.authService.handleError(error))
        );
    }

    /**
     * Get the current orders state
     */
    getOrdersSnapshot(): ReceivingOrderListingResponse | null {
        return this._orders.value;
    }

    /**
     * Get single receiving order detail
     * @param orderId Order ID
     * @param schema Organization schema
     */
    getReceivingOrderDetail(orderId: string | number, schema: string): Observable<any> {
        this.loadingSubject.next(true);
        const url = `${this._liveApiUrl}/customer/customer-order/${orderId}?schema=${schema}`;
        return this.http.get<any>(url).pipe(
            map(data => {
                this.loadingSubject.next(false);
                return data;
            }),
            catchError(error => {
                this.loadingSubject.next(false);
                return this.authService.handleError(error);
            })
        );
    }
       recivingorderDetailRNC(id:any,schema:any,page:number=1,){
    const order_id = Number(id.replace(/\D/g, ''));
    // const numericPart = ids.replace(/\D/g, '');
    // const idNumber = parseInt(numericPart, 10);
    console.log(order_id);
    return this.http
    .get<any>(`${this._liveApiUrl}/notification/get-customer-notification/?order_id=${order_id}&page=1&type=Custom Order Notification&schema=${schema}&notification_admin_type=nonGeneral`)
    .pipe(
      map((data) => {
        return data;
      }),
      catchError(this.authService.handleError)
    );
  }
    recivingorderDetailAllRNC(id:any,schema:any,page:number=1,){
    const order_id = Number(id.replace(/\D/g, ''));
    // const numericPart = ids.replace(/\D/g, '');
    // const idNumber = parseInt(numericPart, 10);
    console.log(order_id);
    return this.http
    .get<any>(`${this._liveApiUrl}/notification/get-customer-notification/?order_id=${order_id}&page=all&type=Custom Order Notification&schema=${schema}&notification_admin_type=nonGeneral`)
    .pipe(
      map((data) => {
        return data;
      }),
      catchError(this.authService.handleError)
    );
  }
}
